var _circle, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5247,
    cy: 24.5247,
    r: 24.5247,
    fill: "#D1FFEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9688 14.2585H23.3832V34.7909H15.9688V14.2585Z",
    fill: "#79DFBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6299 21.2018H9.125V27.9468H23.6299C35.2338 27.9468 37.8014 18.8213 37.6347 14.2585H30.7323C30.7323 19.8925 25.9974 21.2349 23.6299 21.2018Z",
    fill: "#8FDEC3"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6299 27.8475H9.125V21.1026H23.6299C35.2338 21.1026 37.8014 30.228 37.6347 34.7908H30.7323C30.7323 29.1568 25.9974 27.8144 23.6299 27.8475Z",
    fill: "#8CE3C4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.137549f3f223d2c6a5430cfe8dbea20a.svg";
export { ForwardRef as ReactComponent };